function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M.28 8.443A.909.909 0 001.564 9.73l3.44-3.44 3.443 3.445A.91.91 0 009.733 8.45L6.289 5.004l3.458-3.458A.909.909 0 008.461.261L5.004 3.718 1.552.266A.91.91 0 00.267 1.55l3.452 3.453-3.44 3.44z",
  fill: "#9BADBC",
  fillRule: "evenodd"
});

var SvgClose = function SvgClose(props) {
  return React.createElement("svg", _extends({
    width: 10,
    height: 10
  }, props), _ref);
};

export default SvgClose;